export const footerContent = `
<style>
    @font-face {
        font-weight: 400;
        font-family: YouNik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/YouNik-Regular.woff") format("woff");
        font-display: swap;
    }
    @font-face {
        font-weight: 500;
        font-family: YouNik;
        font-style: normal;
        src: url("https://s.c.dk/fonts/YouNik-Medium.woff") format("woff");
        font-display: swap;
    }
</style>

<style>
    .nd-footer .link {
        cursor: pointer;
        font-weight: inherit;
        text-decoration-line: none;
        background: transparent;
        border: none;
    }
    .nd-footer .link:hover {
        text-decoration-line: underline;
    }
    .nd-footer .link._primary {
        color: #0f140a;
        text-decoration-color: #0f140a;
    }
    .nd-footer .link._secondary {
        color: var(--primary-text-color, #000000cc);
        text-decoration-color: var(--primary-text-color, #000000cc);
    }
    .nd-footer .link._legal-info {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
        font-weight: 500;
        color: #0000008f;
        text-decoration-color: #0000008f;
    }
    .nd-footer .link._underline-on-hover {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-on-hover:hover {
        text-decoration-line: underline;
    }
    .nd-footer .link._underline-on-mouse-leave {
        text-decoration-line: underline;
    }
    .nd-footer .link._underline-on-mouse-leave:hover {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-none {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-none:hover {
        text-decoration-line: none;
    }
    .nd-footer .link._underline-always {
        text-decoration-line: underline;
    }
    .nd-footer .link._underline-always:hover {
        text-decoration-line: underline;
    }
    .nd-footer .link._large {
        font-size: var(--font-large-font-size, 1.125rem);
        line-height: var(--font-large-line-height, 1.1112);
    }
    .nd-footer .link._medium {
        font-size: var(--font-big-font-size, 1rem);
        line-height: var(--font-big-line-height, 1.125);
    }
    .nd-footer .link._small {
        font-size: var(--font-medium-font-size, 0.875rem);
        font-weight: var(--font-base-font-weight, 400);
        line-height: var(--font-medium-line-height, 1.0715);
    }
    .nd-footer .link._extra-small {
        font-size: var(--font-small-font-size, 0.75rem);
        line-height: var(--font-small-line-height, 1.1667);
    }
    .nd-footer .link._bold {
        font-weight: var(--bold-font-weight, 500);
    }
    .nd-footer .link._primary-colored {
        color: var(--primary-color, #00dc00);
    }

</style>
<style>
    .nd-footer {
        margin: 0;
        box-sizing: border-box;
        content-visibility: auto;
        background-color: #ffffff;
        padding-block: 24px;
        font-family: "YouNik", sans-serif;
        font-size: 1rem;
        font-weight: 400;
        font-style: normal;
        font-feature-settings: "tnum";
        -webkit-font-smoothing: antialiased;
        letter-spacing: 0.15px;
        border-top: 1px solid #221f0e3b;
    }

    .nd-footer * {
        box-sizing: border-box;
    }

    .nd-footer a {
        text-decoration: none;
    }

    .nd-footer button {
        font-family: inherit;
    }

    .nd-footer__inner.page-limiter {
        max-width: 1200px;
        width: 100%;
        margin: auto;
    }

    @media screen and (min-width: 1025px) and (max-width: 1249.999px) {
        .nd-footer__inner.page-limiter {
            padding-inline: 24px;
        }
    }

    @media screen and (max-width: 1024px) {
        .nd-footer__inner.page-limiter {
            padding-inline: 16px;
        }
    }

    /* START: Styles for top links in the footer */
    .nd-footer__shortcuts {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        word-break: break-word;
        gap: 32px 48px;
        padding-top: 32px;
        padding-bottom: 32px;
    }
    .nd-footer__shortcut {
        display: flex;
        gap: 8px;
        align-items: center;
        letter-spacing: 0.2px;

        color: #000000;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        text-decoration: none;
    }

    .nd-footer__shortcut:hover {
        text-decoration: underline;
    }

    .nd-footer__shortcut-icon-container {
        margin: 0;
    }
    /* Styles for footer links */
    .nd-footer__groups {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 40px 0;
        gap: 16px;
    }

    .nd-footer__groups._desktop {
        display: flex;
    }

    .nd-footer__groups._mobile {
        display: none;
    }

    .nd-footer__group {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        gap: 12px;
        min-width: 176px;
        max-width: 221px;
    }

    .nd-footer__group-name {
        color: #0000008f;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        cursor: default;
        margin-bottom: 8px;
    }

    /* Styles for footer bottom */
    .nd-footer__info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 40px 0;
        border-top: 1px solid #221f0e3b;
    }

    .nd-footer__social-media {
        display: flex;
        gap: 16px;
        flex: 1 1 0;
        align-items: center;
    }

    .nd-footer__social-media > .nd-footer__social-media-link {
        border-radius: 50%;
        display: flex;
        width: 36px;
        height: 36px;
        justify-content: center;
        align-items: center;
    }

    .nd-footer__social-media-link:focus-visible {
        border-radius: 1px;
        outline: 2px dashed #000000cc;
        outline-offset: 2px;
    }

    .nd-footer__logo {
        display: flex;
        align-items: center;
    }

    .nd-footer__logo-link:focus-visible {
        border-radius: 1px;
        outline: 2px dashed #000000cc;
        outline-offset: 2px;
    }

    .nd-footer__logo_nuuday {
        flex: 1 1 0;
        justify-content: flex-end;
    }

    .nd-footer__separator {
        border: 1px solid rgba(0, 0, 0, 0.12);
        margin: 16px 0;
    }

    .nd-footer__separator._mobile {
        display: none;
    }

    .nd-footer__address,
    .nd-footer__legal {
        display: flex;
        letter-spacing: 0.15px;
        font-size: 14px;
        font-weight: 500;
        line-height: 15px;
        text-align: center;
        color: #0000008f;
    }

    .nd-footer__complex-address {
        display: flex;
        align-items: center;
        color: #000000cc;
        font-size: 14px;
        font-weight: 500;
        line-height: 15px;
        text-align: center;
    }

    .nd-footer__address {
        gap: 16px;
        cursor: default;
        font-style: normal;
        margin-left: 8px;
        margin-right: auto;
    }

    .nd-footer__legal-item {
        position: relative;
        white-space: nowrap;
    }

    .nd-footer__address-part:not(:last-child),
    .nd-footer__legal-item:not(:last-child) {
        margin-right: 1.5ch;
    }

    .nd-footer__address-part:not(:last-child)::after,
    .nd-footer__legal-item:not(:last-child)::after {
        content: "·";
        position: absolute;
        right: -1ch;
    }

    .nd-footer__bottom-info {
        opacity: 80%;
    }

    @media screen and (max-width: 1024px) {
        .nd-footer__groups {
            justify-content: flex-start;
        }

        .nd-footer__bottom-info {
            flex-direction: column;
            gap: 16px;
            padding: 32px 0 8px;
        }

        .nd-footer__complex-address {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .nd-footer__address {
            flex-direction: column;
            align-items: center;
            gap: 24px;
            margin-left: unset;
            margin-right: unset;
        }

        .nd-footer__address-part:not(:last-child)::after {
            display: none;
        }

        .nd-footer__address + .nd-footer__legal {
            margin-top: 16px;
            justify-content: center;
        }
    }

    @media screen and (max-width: 768px) {
        .nd-footer__groups._desktop {
            display: none;
        }

        .nd-footer__groups._mobile {
            display: flex;
            padding: 32px 0;
        }

        .nd-footer__shortcuts {
            align-items: flex-start;
            padding-top: 12px;
            padding-bottom: 32px;
            border-bottom: 1px solid #221f0e3b;
        }

        .nd-footer__shortcut {
            flex-direction: column;
            font-size: 16px;
            line-height: 24px;
            text-decoration: none;
            flex: 1 1 75px;
            max-width: 100px;
            min-width: 75px;
            text-align: center;
        }

        .nd-footer__shortcut img {
            width: 36px;
            height: 36px;
        }

        .nd-footer__shortcut:hover {
            text-decoration: underline;
        }

        .nd-footer__separator {
            margin: 3px 0;
        }

        .nd-footer__separator._mobile {
            display: none;
        }

        .nd-footer__group-name,
        .nd-footer__accordion-panel > a {
            color: #000000cc;
            font-size: 16px;
            font-weight: 500;
            line-height: 18px;
        }

        .nd-footer__accordion {
            width: 100%;
            cursor: pointer;
            transition-duration: 0.4s;
            user-select: none;
        }

        .nd-footer__accordion-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .nd-footer__accordion-icon {
            padding: 5px;
            border: 1px solid #221f0e3b;
            border-radius: 50%;
        }

        .nd-footer__accordion-header .nd-footer__accordion-icon {
            transition: transform 0.4s;
        }

        .nd-footer__accordion-header:focus-visible {
            outline: none;
        }

        .nd-footer__accordion-header:focus-visible .nd-footer__accordion-icon {
            background: #4637000f;
            border: 2px dashed #000000cc;
            border-radius: 100px;
            outline: none;
        }

        .nd-footer__accordion._active .nd-footer__accordion-icon {
            transform: rotate(180deg);
        }

        .nd-footer__accordion-panel {
            max-height: 0;
            transition: max-height 0.4s ease-out, padding 0.4s ease-out,
                opacity 0.4s ease-out;
            overflow-y: hidden;
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 0 24px;
            opacity: 0;
        }

        .nd-footer__accordion._active .nd-footer__accordion-panel {
            height: fit-content;
            max-height: 100vh;
            padding: 24px;
            opacity: 1;
        }

        .nd-footer__bottom-links {
            padding: 32px 0;
        }

        .nd-footer__emarket-icon-wrapper {
            text-align: center;
        }
    }

    @media screen and (max-width: 560px) {
        .nd-footer__shortcuts {
            gap: 24px;
        }

        .nd-footer__bottom-links {
            flex-direction: column;
            align-items: center;
            gap: 32px;
        }
    }
</style>
    <div class="nd-footer" >
        <div class="nd-footer__inner page-limiter">
            <nav class="nd-footer__shortcuts">


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://selvbetjening.yousee.dk"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/2BaQqwNVfoXdOu1oc1d6jp/c68ede9f209f9d0b002724f5a3346d9a/mit-yousee-dark.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        Mit YouSee

</a>


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://sentry-authn.yousee.dk/oauth/authorize?client_id=zimbra-webmail-prod&amp;redirect_uri=https%3A%2F%2Fmityousee-odinapi.yousee.dk%2Fyousee%2Fselfcare%2Fprofile%2Fdelegated-authenticate%2Fwebmail%2Ftokens&amp;response_type=code"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/13ENZDwodFmMm6ACEKUNyA/22ff6bb07d9214d7bccecd93d0c5aceb/mail-dark.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        Webmail

</a>


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://musik.yousee.dk"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/3PlnGDtl8OZ1t5e6jdPwWx/a27e485ee6f32a77923f778b694ae229/music-dark.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        YouSee Musik

</a>


<a
class="link _secondary _small _underline-on-hover _bold nd-footer__shortcut"

tabindex="0"
href="https://play.yousee.dk"

>
                        <figure class="nd-footer__shortcut-icon-container">
                            <img src="//images.ctfassets.net/qn2mzafc6iit/74yySyMd4CeTmzqhyCZKpz/0145a3e7beb930d0929b392cd1edca0c/play_mobile_bottom_link.svg?w=48&h=48" alt="" class="nd-footer__shortcut-icon" width="48" height="48"/>
                        </figure>
                        YouSee Play

</a>
            </nav>
            <div class="nd-footer__groups _desktop">
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Hjælp</div>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/hjaelp"

>
                            Gå til hjælp

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://selvbetjening.yousee.dk"

>
                            Mit YouSee

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                            Driftsinformation

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                            Tjek din hastighed

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/flytadresse"

>
                            Flyt adresse

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/hjaelp/kontakt"

>
                            Kontakt os

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Produkter</div>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/tv"

>
                            Tv &amp; Streaming

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/internet"

>
                            Internet

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/internet/coax"

>
                            Internet via antennestikket

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/internet/fibernet"

>
                            Fibernet

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/mobilabonnement"

>
                            Mobilabonnementer

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/mobiltelefoner"

>
                            Mobiltelefoner

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/internet/5g-internet"

>
                            Mobilt Internet

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/tv/tv-pakker"

>
                            Fast tv-pakke abonnementer

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/smartwatch"

>
                            Smartwatches

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/tilbehoer"

>
                            Tilbehør

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Mærker</div>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/apple"

>
                            Apple

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/samsung"

>
                            Samsung

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/google"

>
                            Google

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/xiaomi"

>
                            Xiaomi

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/motorola"

>
                            Motorola

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Streamingtjenester</div>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/netflix"

>
                            Netflix

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/tv2play"

>
                            TV 2 Play

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/viaplay"

>
                            Viaplay

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/disneyplus"

>
                            Disney+

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/hbo-max"

>
                            HBO Max

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/prime-video"

>
                            Prime Video

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/shop/yousee-play/kanaloverblik"

>
                            Alle streamingtjenester og kanaler

</a>
                </div>
                <div class="nd-footer__group">
                    <div class="nd-footer__group-name">Om Yousee</div>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://tdc.csod.com/ux/ats/careersite/17/home?c=tdc"

>
                            Karriere

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/hjaelp/butik"

>
                            Find YouSee butik

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://nuuday.dk/presse"

>
                            Presse

</a>


<a
class="link _secondary _small _underline-on-hover _bold"

tabindex="0"
href="https://yousee.dk/5g"

>
                            Danmarks bedste mobilnet

</a>
                </div>
            </div>

            <hr class="nd-footer__separator _mobile">
            <div class="nd-footer__groups _mobile">
                    <div class="nd-footer__accordion">
                        <div class="nd-footer__accordion-header" tabindex="0">
                            <div class="nd-footer__group-name">Hjælp</div>
                            <img class="nd-footer__accordion-icon" alt="" src="https://yousee.dk/shop/images/icons/nuuday/accorddion-expand.svg" width="32" height="32"/>
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/hjaelp"

>
                                    Gå til hjælp

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://selvbetjening.yousee.dk"

>
                                    Mit YouSee

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/hjaelp/driftsinformation"

>
                                    Driftsinformation

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/hjaelp/hastighedstest"

>
                                    Tjek din hastighed

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/flytadresse"

>
                                    Flyt adresse

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/hjaelp/kontakt"

>
                                    Kontakt os

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion">
                        <div class="nd-footer__accordion-header" tabindex="0">
                            <div class="nd-footer__group-name">Produkter</div>
                            <img class="nd-footer__accordion-icon" alt="" src="https://yousee.dk/shop/images/icons/nuuday/accorddion-expand.svg" width="32" height="32"/>
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/tv"

>
                                    Tv &amp; Streaming

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/internet"

>
                                    Internet

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/internet/coax"

>
                                    Internet via antennestikket

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/internet/fibernet"

>
                                    Fibernet

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/mobilabonnement"

>
                                    Mobilabonnementer

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/mobiltelefoner"

>
                                    Mobiltelefoner

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/internet/5g-internet"

>
                                    Mobilt Internet

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/tv/tv-pakker"

>
                                    Fast tv-pakke abonnementer

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/smartwatch"

>
                                    Smartwatches

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/tilbehoer"

>
                                    Tilbehør

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion">
                        <div class="nd-footer__accordion-header" tabindex="0">
                            <div class="nd-footer__group-name">Mærker</div>
                            <img class="nd-footer__accordion-icon" alt="" src="https://yousee.dk/shop/images/icons/nuuday/accorddion-expand.svg" width="32" height="32"/>
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/apple"

>
                                    Apple

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/samsung"

>
                                    Samsung

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/google"

>
                                    Google

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/xiaomi"

>
                                    Xiaomi

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/motorola"

>
                                    Motorola

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion">
                        <div class="nd-footer__accordion-header" tabindex="0">
                            <div class="nd-footer__group-name">Streamingtjenester</div>
                            <img class="nd-footer__accordion-icon" alt="" src="https://yousee.dk/shop/images/icons/nuuday/accorddion-expand.svg" width="32" height="32"/>
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/netflix"

>
                                    Netflix

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/tv2play"

>
                                    TV 2 Play

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/viaplay"

>
                                    Viaplay

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/disneyplus"

>
                                    Disney+

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/hbo-max"

>
                                    HBO Max

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/prime-video"

>
                                    Prime Video

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/shop/yousee-play/kanaloverblik"

>
                                    Alle streamingtjenester og kanaler

</a>
                        </div>
                    </div>
                    <div class="nd-footer__accordion">
                        <div class="nd-footer__accordion-header" tabindex="0">
                            <div class="nd-footer__group-name">Om Yousee</div>
                            <img class="nd-footer__accordion-icon" alt="" src="https://yousee.dk/shop/images/icons/nuuday/accorddion-expand.svg" width="32" height="32"/>
                        </div>
                        <div class="nd-footer__accordion-panel">


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://tdc.csod.com/ux/ats/careersite/17/home?c=tdc"

>
                                    Karriere

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/hjaelp/butik"

>
                                    Find YouSee butik

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://nuuday.dk/presse"

>
                                    Presse

</a>


<a
class="link _secondary _medium _underline-on-hover"

tabindex="-1"
href="https://yousee.dk/5g"

>
                                    Danmarks bedste mobilnet

</a>
                        </div>
                    </div>
            </div>
            <hr class="nd-footer__separator _mobile">

            <div class="nd-footer__info nd-footer__bottom-links">
                <div class="nd-footer__social-media">



<a
class="button _outlined _large   _onlyIcon  nd-footer__social-media-link"
style="
    "
    
    
    tabindex="0"
    href="https://www.facebook.com/youseedanmark"
        target="_blank"
    
>
                                <img src="//images.ctfassets.net/qn2mzafc6iit/VswOIxxKhS6dplmaR2viF/7113480aa89eb9e1d94c48d456ea27c9/facebook-dark.svg?w=36&h=36" alt="Facebook" />

</a>



<a
class="button _outlined _large   _onlyIcon  nd-footer__social-media-link"
style="
    "
    
    
    tabindex="0"
    href="https://www.youtube.com/channel/UC3p7fPsSYAFRI1gY95ktxkQ"
        target="_blank"
    
>
                                <img src="//images.ctfassets.net/qn2mzafc6iit/6IGmIJXGjc7iT0MdgA9U6R/0a1f79c81cf84cb6c30b7bee68e6e993/youtube-dark.svg?w=36&h=36" alt="YouTube" />

</a>
                </div>
                <div class="nd-footer__logo nd-footer__logo_yousee">
                    <a class="nd-footer__logo-link" href="https://yousee.dk">
                        <img class="nd-footer__logo-image" src="https://yousee.dk/shop/images/nuuday/yousee-logo.svg" alt="YouSee" loading="lazy" width="120" height="34"/>
                    </a>
                </div>
                <div class="nd-footer__logo nd-footer__logo_nuuday">
                    <a class="nd-footer__logo-link" href=https://nuuday.com/>
                        <img class="nd-footer__logo-image" src="https://yousee.dk/shop/images/nuuday/a-nuuday-company-logo.svg" alt="Nuuday" loading="lazy" width="108" height="41"/>
                    </a>
                </div>
            </div>

            <hr class="nd-footer__separator _mobile">

            <div class="nd-footer__info nd-footer__bottom-info">
                    <div class="nd-footer__emarket-icon-wrapper">


<a
class="link _secondary _small _underline-on-hover"

tabindex="0"
href="https://certifikat.emaerket.dk/yousee.dk"
target="_blank"
>
                            <img alt="E-Mærket" src="//images.ctfassets.net/qn2mzafc6iit/299t3XJoVtwR9FhRTo8d3U/b37f9c77aec27e612a64180554f9db6d/E-maerket.svg?w=30&h=16"
                                 height="16" width="30">

</a>
                    </div>
                <address class="nd-footer__address">
                    <div class="nd-footer__complex-address">
                            <span class="nd-footer__address-part">YouSee · Teglholmsgade 1 · 2450 København SV</span>
                            <span class="nd-footer__address-part">CVR:  40 07 52 91</span>
                    </div>
                </address>
                <div class="nd-footer__legal">


<a
class="link _legal-info _ _underline-on-hover nd-footer__legal-item"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/vilkar-and-abonnement"

>
                            Vilkår &amp; abonnementer

</a>


<a
class="link _legal-info _ _underline-on-hover nd-footer__legal-item"

tabindex="0"
href="https://yousee.dk/hjaelp/kategori/persondatameddelelser"

>
                            Persondata

</a>


<a
class="link _legal-info _ _underline-on-hover nd-footer__legal-item"

tabindex="0"
href="https://yousee.dk/om-yousee/om-cookies"

>
                            Cookies

</a>
                </div>
            </div>
        </div>
    </div>
    <script>
        (() => {
            const ACTIVE_MODIFIER = "_active";
            let accordionElements = document.querySelectorAll(".nd-footer__accordion");
    
            Array.from(accordionElements).forEach((e) => {
                e.addEventListener("click", function () {
                    removeAllActiveModifiers(this);
                    this.classList.toggle(
                        ACTIVE_MODIFIER,
                        !this.classList.contains(ACTIVE_MODIFIER)
                    );
                });
            });
    
            function removeAllActiveModifiers(currentElement) {
                accordionElements.forEach((e) => {
                    currentElement !== e && e.classList.remove(ACTIVE_MODIFIER);
                });
            }
        })();
    </script>
`;
